import { Check, EyeOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { CollaborateTaskData } from 'types/api/collaborate';
import {
  statusAvatarColor,
  textColor,
  urgencyAvatarColor,
} from 'utils/constants';

export default function TaskSticky({ task, taskHovered }: { task: Partial<CollaborateTaskData>, taskHovered: boolean }) {
  const { t } = useTranslation();
  const urgencyColor = urgencyAvatarColor[task.task_priority as keyof typeof urgencyAvatarColor];
  const statusColor = statusAvatarColor[task.task_status as keyof typeof statusAvatarColor];
  const fontColor = textColor[task.task_status as keyof typeof textColor];

  if (task.is_complete) {
    return (
      <div className="bg-primary relative flex h-8 w-8 items-center justify-center overflow-hidden rounded-[15%_50%_50%_50%] p-1 shadow-md">
        <div className="bg-primary absolute right-0 top-0 h-full w-full -translate-y-1/2 translate-x-1/2 transform rounded-full" />
        <span className="relative z-10 text-xs font-normal text-white transition-all duration-500 ease-in-out"
          aria-label={t('task_sticky.completed', 'Task completed')}>
          {taskHovered ? (
            <span className='text-black'>{
              task.task_comment_id
            }
            </span>
          ) : (

            <Check size={16} strokeWidth={3} />
          )}
        </span>
      </div>
    );
  }

  return (
    <div
      className="relative flex h-8 w-8 items-center justify-center overflow-hidden rounded-[15%_50%_50%_50%] p-1 shadow-md"
      style={{ backgroundColor: statusColor, color: fontColor }}
    >
      <div
        className="absolute right-0 top-0 h-full w-full -translate-y-1/2 translate-x-1/2 transform rounded-full"
        style={{ backgroundColor: urgencyColor, color: fontColor }}
      />
      <span className="relative z-10 text-xs font-normal ">
        {task.is_internal ? (
          <EyeOff
            size={18}
            style={{ color: fontColor }}
            aria-label={t('task_sticky.internal', 'Internal task')}
          />
        ) : (
          task.task_comment_id
        )}
      </span>
    </div>
  );
}